import React from "react";
import { Play, Gift, Sparkles, CheckCircle2 } from "lucide-react";

const HeroSection = ({ navigateTo }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 md:py-24 flex flex-col lg:flex-row items-center gap-12 border-b border-slate-100">
      
      {/* LEVÁ STRANA: TEXTY A TLAČÍTKA */}
      <div className="lg:w-1/2 space-y-8">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-black text-[#2a3b4c] leading-[1.1] tracking-tight">
          Z vašeho kola
          <br />
          <span className="text-green-600">
            elektrokolo za
            <br />
            zlomek ceny
          </span>
        </h1>
        
        <div className="space-y-4">
          <p className="text-slate-600 text-xl leading-relaxed">
            <span className="font-bold text-green-600">
              Ušetřete více než 50 % a získejte brutální parametry!
            </span>
          </p>
          
          {/* SEZNAM BENEFITŮ S NOVÝM BODEM */}
          <ul className="space-y-3">
            <li className="flex items-center gap-2 text-slate-700 font-medium">
              <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" /> 
              Montáž zvládnete sami za jedno odpoledne
            </li>
            <li className="flex items-center gap-2 text-slate-700 font-medium">
              <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" /> 
              České zázemí a plná záruka 24 měsíců
            </li>
            <li className="flex items-center gap-2 text-[#2a3b4c] font-bold">
              <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" /> 
              Garantujeme nejnižší ceny na českém trhu
            </li>
          </ul>
        </div>
        
        {/* TLAČÍTKA A CENA OD */}
        <div className="space-y-6 pt-4">
          <div className="flex flex-wrap gap-5">
            <button
              onClick={() => navigateTo("products")}
              className="px-10 py-5 bg-green-600 text-white font-black rounded-2xl shadow-xl shadow-green-600/30 hover:bg-green-500 hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 text-lg uppercase tracking-wide"
            >
              Sestavit kit se slevou
            </button>

            <button
              onClick={() => navigateTo("guides")}
              className="px-8 py-5 bg-white border-2 border-slate-200 text-slate-700 font-bold rounded-2xl shadow-sm hover:bg-slate-50 hover:-translate-y-1 hover:shadow-md transition-all duration-300 flex items-center gap-2 text-lg"
            >
              <Play className="w-5 h-5 text-green-600 fill-current" /> Jak na montáž?
            </button>
          </div>
          
          <div className="flex items-center gap-3 px-2">
            <div className="h-1 w-12 bg-slate-200 rounded-full"></div>
            <p className="text-slate-500 font-medium text-lg">
              Kompletní přestavba již od <span className="text-[#2a3b4c] font-black text-2xl">20 900 Kč</span>
            </p>
          </div>
        </div>
      </div>

      {/* PRAVÁ STRANA: SLEVA + OBRÁZEK */}
      <div className="lg:w-1/2 w-full flex flex-col gap-6">
        
        {/* VELKÝ PROMO BOX SE SLEVOU */}
        <div className="relative group overflow-hidden bg-gradient-to-br from-amber-400 via-orange-500 to-red-500 p-[2px] rounded-3xl shadow-2xl shadow-orange-500/20 transform hover:scale-[1.02] transition-transform duration-300">
          <div className="bg-white rounded-[22px] p-6 md:p-8 relative overflow-hidden">
            <div className="absolute -right-4 -top-4 text-orange-100 rotate-12 group-hover:scale-110 transition-transform duration-500">
              <Gift size={120} />
            </div>

            <div className="relative z-10">
              <div className="flex items-center gap-2 text-orange-600 font-black uppercase tracking-widest text-sm mb-2">
                <span className="flex h-2 w-2 rounded-full bg-orange-600 animate-ping"></span>
                <Sparkles className="w-5 h-5" /> Časově omezená nabídka
              </div>
              <h2 className="text-3xl md:text-4xl font-black text-slate-900 leading-none">
                UŠETŘETE <span className="text-orange-600 text-4xl md:text-5xl">2 000 Kč</span>
              </h2>
              <p className="text-slate-600 mt-3 text-lg font-medium max-w-[90%] leading-tight">
                Při nákupu <span className="text-slate-900 font-bold">celého setu</span> (motor + baterie + displej) vám automaticky odečteme 2 000 Kč z celkové ceny.
              </p>
              
              <div className="mt-5 flex items-center gap-3">
                <div className="bg-orange-600 text-white px-4 py-2 rounded-xl font-black text-sm shadow-md shadow-orange-600/30">
                  AKTIVOVÁNO V KONFIGURÁTORU
                </div>
                <div className="text-slate-400 font-bold text-xs uppercase italic">
                  *Platí do vyprodání zásob
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* OBRÁZEK KOLA */}
        <div className="bg-white p-4 rounded-3xl shadow-xl border border-slate-100 relative group">
          <img
            src="/images/uvodkolo.png"
            alt="Přestavba kola na elektrokolo"
            className="w-full h-auto rounded-2xl mix-blend-multiply group-hover:scale-[1.02] transition-transform duration-500"
          />
        </div>
      </div>

    </div>
  );
};

export default HeroSection;